import { render, staticRenderFns } from "./ImsMsrb.vue?vue&type=template&id=5087b3d6&"
import script from "./ImsMsrb.vue?vue&type=script&lang=js&"
export * from "./ImsMsrb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports